import { Record } from './record';
import { OtkList } from './user-item-list';

export interface Collection {
  dateEnd?: Date;
  dateIni?: Date;
  hostId?: number;
  id: number;
  name: string;
  orden?: number;
  query?: string;
  records: Record[];
  userLists?: OtkList[];
  topTenTitles?: object;
  titlesIds?: string[];
  /**
   * This property refers to the type of collection - Enum ToptenCollectionType
   */
  topten?: string;
  featured?: boolean;
  fromUserList?: boolean;
  items?: Record[] | OtkList[];
  orderBy?: string;
}

export interface CollectionTitle {
  name: string;
  key: string;
}

export const collectionTitles = {
  novedades: 'collections.new',
  masvisitados: 'collections.mostVisited',
  masvisitadosultimos30dias: 'collections.mostVisitedLastMonth',
  masprestados: 'collections.mostPopular',
  masprestadosultimos30dias: 'collections.mostPopularLastMonth',
  destacados: 'collections.featured',
  recommendedForYou: 'collections.forYou',
  mandatoryTraining: 'mandatory_training.title',
};

export enum ToptenCollectionType {
  JUST_ARRIVED = 'novedades',
  MOST_VISITED = 'masvisitados',
  MOST_VISITED_LAST_MONTH = 'masvisitadosultimos30dias',
  MOST_POPULAR = 'masprestados',
  MOST_POPULAR_LAST_MONTH = 'masprestadosultimos30dias',
  FEATURED = 'destacados',
  RECOMMENDED_FOR_YOU = 'recommendedForYou',
  TRENDING_NOW = 'trendingNow',
  GENERIC = 'generic',
  /**
   * Collection created by manual selection
   */
  GENERIC_BY_SELECTION = 'genericBySelection',
  GENERIC_BY_LIST_SELECTION = 'genericByListSelection',
  OLE = 'OLE',
  MANDATORY_TRAINING = 'mandatoryTraining',
}